var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({'width':'100%'}),on:{"click":_vm.modal_file_input}},[_vm._t("default")],2),_c('input',{ref:"inputFile",style:({display:'none'}),attrs:{"type":"file"},on:{"change":_vm.otherFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }